import { Box } from '@mui/system';
import React, { useContext, useEffect, useRef, useState } from 'react';
import InformationModal from '../../ifsp/InformationModal';
import ModalPopup from '../../../components/formlib/ModalPopup';
import MediumTypography from '../../../components/formlib/MediumTypography';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { ReactComponent as DownArrow } from '../../../assets/images/downarrowcolored.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/images/deleteAlertIcon.svg';
import { ReactComponent as UpArrow } from '../../../assets/images/uparrowcolored.svg';
import { ReactComponent as InfoIcon } from '../../../assets/images/infoIcon.svg';
import CommentTextbox from '../../../components/formlib/CommentTextbox';
import { LoaderContext, LoaderContextType } from '../../../layouts/AppSidebar';
import { AlertColor } from '@mui/material';
import SnackBarComponent from '../../../components/formlib/SnackBarComponent';
import {
  addOrUpdateIfspFamilyConcernReport,
  deleteIfspFamilyConcern,
  getIfspFamilyConcernReport,
} from '../../../services/ifspClient/IfspApi';
import {
  setIfspFamilyConcernReport,
  updateIfspFamilyConcernReport,
  updateOriginalIfspFamilyConcernReport,
} from '../../../redux/features/ifsp/ifspFamilyConcernSlice';
import ButtonComponent from '../../../components/formlib/ButtonComponent';
import dayjs from 'dayjs';
import { useIfspUnsavedChanges } from '../ifspUnsavedChanges';
import IfspHeld from '../ifspComponents/IfspHeld';

const FamilyConcernsPrioritiesandResourcesReport = () => {
  const ifspFamilyConcernReport = useAppSelector(
    (state) => state.ifspFamilyConcernReportDetails.ifspFamilyConcernReport,
  );
  const originalIfspFamilyConcernReport = useAppSelector(
    (state) =>
      state.ifspFamilyConcernReportDetails.originalIfspFamilyConcernReport,
  );

  const ifspPermission = useAppSelector((state) => state.ifspPermissionDetails);
  const dispatch = useAppDispatch();

  const [openAccordianIndex, setOpenAccordianIndex] = useState<number>(0);
  const [openAccordian, setOpenAccordian] = useState<boolean>(false);
  const [transitionRenderKey, setTransitionRenderKey] = useState(0);
  const [deleteNewSection, setDeleteNewSection] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [toastrVariable, setToastrVariable] = useState<AlertColor>('info');
  const [toastrDefaultMessage, setToastrDefaultMessage] = useState('');
  const [infoModal, setInfoModal] = useState(false);
  const [toastrId, setToastrId] = useState('');
  const [openUnSavedModal, setOpenUnSavedModal] = useState<boolean>(false);
  const { toggleLoader } = useContext(LoaderContext) as LoaderContextType;

  const parentRef = useRef<HTMLDivElement>(null);
  const { isFamilyConcernsChanged, isFamilyConcernsChangedAndNoCreatedDate } =
    useIfspUnsavedChanges();

  useEffect(() => {
    toggleLoader(true);
    handleGetIfspFamilyConcernReport();
  }, []);

  const handleGetIfspFamilyConcernReport = () => {
    getIfspFamilyConcernReport()
      .then((response) => {
        if (response) {
          toggleLoader(false);
          dispatch(setIfspFamilyConcernReport(response));
        }
      })
      .catch(() => {
        setOpen(true);
        setToastrVariable('error');
        setToastrId('IFSP.FamilyConcern.FetchError');
        setToastrDefaultMessage('Failed to fetch family concerns');
        toggleLoader(false);
      });
  };

  const createNewSection = () => {
    dispatch(
      updateIfspFamilyConcernReport({
        ...ifspFamilyConcernReport,
        familyConcerns: [
          ...ifspFamilyConcernReport.familyConcerns,
          {
            id: '',
            concernsComment: '',
            prioritiesComment: '',
            materialResourceComment: '',
            informationalResourceComment: '',
            supportiveResourceComment: '',
            sessionReviewedDate: '',
          },
        ],
      }),
    );
    dispatch(
      updateOriginalIfspFamilyConcernReport({
        ...originalIfspFamilyConcernReport,
        familyConcerns: [
          ...originalIfspFamilyConcernReport.familyConcerns,
          {
            id: '',
            concernsComment: '',
            prioritiesComment: '',
            materialResourceComment: '',
            informationalResourceComment: '',
            supportiveResourceComment: '',
            sessionReviewedDate: '',
          },
        ],
      }),
    );
  };

  const deleteSection = () => {
    toggleLoader(true);
    const familyConcernsId =
      ifspFamilyConcernReport.familyConcerns[
        ifspFamilyConcernReport.familyConcerns.length - 1
      ].id;
    if (familyConcernsId) {
      setOpen(true);
      setToastrVariable('success');
      setToastrId('IFSP.FamilyConcern.DeleteSuccess');
      setToastrDefaultMessage('Family concern deleted successfully');
      deleteIfspFamilyConcern(familyConcernsId)
        .then(() => {
          dispatch(
            updateOriginalIfspFamilyConcernReport({
              familyConcerns:
                originalIfspFamilyConcernReport.familyConcerns.slice(0, -1),
            }),
          );
          dispatch(
            updateIfspFamilyConcernReport({
              ...ifspFamilyConcernReport,
              familyConcerns: ifspFamilyConcernReport.familyConcerns.slice(
                0,
                -1,
              ),
            }),
          );
        })
        .catch(() => {
          setOpen(true);
          setToastrVariable('error');
          setToastrId('IFSP.FamilyConcern.DeleteError');
          setToastrDefaultMessage('Failed to delete family concern');
        })
        .finally(() => {
          setDeleteNewSection(false);
          toggleLoader(false);
        });
    } else {
      dispatch(
        updateIfspFamilyConcernReport({
          ...ifspFamilyConcernReport,
          familyConcerns: ifspFamilyConcernReport.familyConcerns.slice(0, -1),
        }),
      );
      dispatch(
        updateOriginalIfspFamilyConcernReport({
          ...originalIfspFamilyConcernReport,
          familyConcerns: originalIfspFamilyConcernReport.familyConcerns.slice(
            0,
            -1,
          ),
        }),
      );
      setDeleteNewSection(false);
      toggleLoader(false);
    }
  };

  const handleCloseSnakBar = (
    _event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleOpenInfoModal = () => {
    setInfoModal(true);
  };

  const handleCloseInfoModal = () => {
    setInfoModal(false);
  };

  const canShowDeleteSection = (mainIndex: number): boolean => {
    const lastIndex = ifspFamilyConcernReport.familyConcerns.length - 1;
    const lastItem = ifspFamilyConcernReport.familyConcerns[lastIndex];

    return (
      ifspPermission.hasClientEditPermission &&
      !lastItem.sessionReviewedDate &&
      mainIndex === lastIndex &&
      mainIndex > 0
    );
  };

  const addOrUpdateIfspReportDetails = () => {
    toggleLoader(true);
    addOrUpdateIfspFamilyConcernReport({
      ...ifspFamilyConcernReport,
      familyConcerns: ifspFamilyConcernReport.familyConcerns.map(
        (item, index) => {
          const isLastIndex =
            ifspFamilyConcernReport.familyConcerns.length - 1 === index;
          return {
            ...item,
            sessionReviewedDate:
              isLastIndex &&
              isFamilyConcernsChangedAndNoCreatedDate &&
              !item.sessionReviewedDate
                ? dayjs().format('MM/DD/YYYY hh:mm A')
                : item.sessionReviewedDate,
          };
        },
      ),
    })
      .then(() => {
        setOpen(true);
        setToastrVariable('success');
        setToastrId('IFSP.FamilyConcerns.UpdateSuccess');
        setToastrDefaultMessage('IFSP Family Concerns updated successfully');
        return handleGetIfspFamilyConcernReport();
      })
      .catch(() => {
        setOpen(true);
        setToastrVariable('error');
        setToastrId('IFSP.FamilyConcerns.UpdateError');
        setToastrDefaultMessage('Failed to update IFSP Family Concerns');
      })
      .finally(() => toggleLoader(false));
  };

  return (
    <Box component="div" className="ml-md mr-md mb-md">
      {ifspFamilyConcernReport.isCurrentlyHeld ? (
        <Box sx={{ position: 'relative' }}>
          <IfspHeld ifspHealBy={ifspFamilyConcernReport?.heldBy} />
        </Box>
      ) : null}
      <Box
        ref={parentRef}
        style={{
          pointerEvents: ifspFamilyConcernReport.isCurrentlyHeld
            ? 'none'
            : 'auto',
          opacity: ifspFamilyConcernReport.isCurrentlyHeld ? '0.5' : '1 ',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onKeyDownCapture={(e) => {
          if (ifspFamilyConcernReport.isCurrentlyHeld) {
            e.preventDefault();
            e.stopPropagation();
          }
        }}
        onFocus={() => {
          if (ifspFamilyConcernReport.isCurrentlyHeld) {
            if (parentRef.current) parentRef.current.focus();
          }
        }}
      >
        <Box
          sx={{
            border: '1px solid #008C82',
            borderBottomLeftRadius: '4px',
            borderBottomRightRadius: '4px',
            borderTop: 'none',
          }}
          className="p-sm"
        >
          <SnackBarComponent
            open={open}
            handleClose={handleCloseSnakBar}
            successOrError={toastrVariable}
            labelId={toastrId}
            defaultMessageId={toastrDefaultMessage}
          />
          <InformationModal
            open={infoModal}
            titleLabel="IFSP.Information"
            titleDefaultLabel="Information"
            buttonLabel="IFSP.InfoOkButton"
            buttonDefaultLabel="Ok"
            onClose={handleCloseInfoModal}
            infoLabelId="IFSP.FamilyOutcomesInfo"
            infoDefaultLabel="Family Outcomes are a way to measure how a family has gained information and achieved success as a result of their participation in an Early Intervention Program. Early Intervention supports families to develop skills in (1) knowing their family rights; (2) communicating their child's needs; and (3) helping their child develop and grow. This information helps other members of your child's team understand your family's concerns, resources and priorities, and supports the development of meaningful outcomes for your child and family."
          />
          <ModalPopup
            open={openUnSavedModal}
            description="UnsavedAlertDescriptionWhileLeaving"
            labelId1="Clientpage.cancelbtn"
            negativeActionLabel="Cancel"
            labelId2="Clientpage.Okbtn"
            positiveActionLabel="Ok"
            onCancel={() => {
              setOpenUnSavedModal(false);
            }}
            onOk={() => {
              dispatch(
                setIfspFamilyConcernReport(originalIfspFamilyConcernReport),
              );
              setTransitionRenderKey((prev) => prev + 1);
              setTimeout(() => {
                setOpenUnSavedModal(false);
              }, 500);
            }}
          />
          <ModalPopup
            open={deleteNewSection}
            description="permanentDeleteConfirmationMessage"
            onOk={() => {
              deleteSection();
            }}
            onCancel={() => {
              setDeleteNewSection(false);
            }}
            labelId1="Clientpage.cancelbtn"
            negativeActionLabel="cancelText"
            labelId2="Clientpage.Okbtn"
            positiveActionLabel="Ok"
          />
          {ifspFamilyConcernReport.familyConcerns.map((ifspData, mainIndex) => (
            <Box
              component="div"
              className="formCardview borderRadius4 mb-lg"
              sx={{
                border: '1px solid #00C6B8',
                backgroundColor: '#ECF9F8',
              }}
              key={ifspData.id}
            >
              <Box component="div" className="flex__justify__space-between">
                {openAccordian && mainIndex === openAccordianIndex ? (
                  <Box component="div" className="flex__ align__items__center">
                    <MediumTypography
                      labelid="IFSP.session4"
                      defaultlabel="Familiy Concerns, Priorities and Resources"
                      fontSize="18px"
                      fontweight={600}
                      textColor="#2A4241"
                      className="pr-md"
                    />
                    <InfoIcon
                      className="cursorPointer"
                      onClick={() => {
                        handleOpenInfoModal();
                      }}
                    />
                    {ifspFamilyConcernReport.familyConcerns[mainIndex]
                      .sessionReviewedDate ? (
                      <Box
                        sx={{
                          display: 'flex',
                          padding: '4px 8px 4px 8px',
                          borderRadius: '4px',
                          marginLeft: '24px',
                          backgroundColor: '#97A6A5',
                          alignItems: 'center',
                        }}
                      >
                        <MediumTypography
                          labelid="IFSP.UpdatedOn"
                          defaultlabel="Created On: "
                          fontSize="14px"
                          fontweight={400}
                          textColor="#fff"
                        />
                        <MediumTypography
                          fontSize="14px"
                          fontweight={400}
                          textColor="#fff"
                          className="pl-xs"
                          label={ifspData.sessionReviewedDate as string}
                        />
                      </Box>
                    ) : null}
                  </Box>
                ) : (
                  <Box className="flex__justify__space-between">
                    <MediumTypography
                      labelid="IFSP.session4"
                      defaultlabel="Familiy Concerns, Priorities and Resources"
                      fontSize="18px"
                      fontweight={600}
                      textColor="#2A4241"
                    />
                    {ifspFamilyConcernReport.familyConcerns[mainIndex]
                      .sessionReviewedDate ? (
                      <Box
                        sx={{
                          display: 'flex',
                          padding: '4px 8px 4px 8px',
                          borderRadius: '4px',
                          marginLeft: '24px',
                          backgroundColor: '#97A6A5',
                          alignItems: 'center',
                        }}
                      >
                        <MediumTypography
                          labelid="IFSP.UpdatedOn"
                          defaultlabel="Created On: "
                          fontSize="14px"
                          fontweight={400}
                          textColor="#fff"
                        />
                        <MediumTypography
                          fontSize="14px"
                          fontweight={400}
                          textColor="#fff"
                          className="pl-xs"
                          label={ifspData.sessionReviewedDate as string}
                        />
                      </Box>
                    ) : null}
                  </Box>
                )}
                {openAccordian && mainIndex === openAccordianIndex ? (
                  <Box className="flex__ align__items__center">
                    {ifspPermission.hasClientEditPermission &&
                    ifspFamilyConcernReport.familyConcerns[
                      ifspFamilyConcernReport.familyConcerns.length - 1
                    ].sessionReviewedDate &&
                    ifspFamilyConcernReport.familyConcerns.length - 1 ===
                      mainIndex ? (
                      <Box
                        className="cursorPointer"
                        sx={{
                          padding: '4px 8px 4px 8px',
                          borderRadius: '4px',
                          marginRight: '24px',
                          border: '1px solid #008C82',
                          backgroundColor: '#fff',
                        }}
                        onClick={() => {
                          createNewSection();
                        }}
                      >
                        <MediumTypography
                          labelid="IFSP.AddNewSection"
                          defaultlabel="+ Add New"
                          fontSize="12px"
                          fontweight={600}
                        />
                      </Box>
                    ) : (
                      canShowDeleteSection(mainIndex) && (
                        <Box
                          component={'div'}
                          className="cursorPointer flex__ align__items__center pr-md"
                          onClick={() => {
                            setDeleteNewSection(true);
                          }}
                          sx={{
                            padding: '4px 8px 4px 8px',
                            borderRadius: '4px',
                            marginRight: '24px',
                            border: '1px solid #EB4C60',
                            backgroundColor: '#fff',
                          }}
                        >
                          <DeleteIcon className="pr-xs" />
                          <MediumTypography
                            labelid="IFSP.DeleteNewSection"
                            defaultlabel="Delete"
                            fontSize="12px"
                            fontweight={600}
                          />
                        </Box>
                      )
                    )}
                    <UpArrow
                      className="cursorPointer"
                      onClick={() => {
                        setOpenAccordianIndex((prev) => prev);
                        setOpenAccordian(false);
                      }}
                    />
                  </Box>
                ) : (
                  <Box className="flex__ align__items__center">
                    {ifspPermission.hasClientEditPermission &&
                    ifspFamilyConcernReport.familyConcerns[
                      ifspFamilyConcernReport.familyConcerns.length - 1
                    ].sessionReviewedDate &&
                    ifspFamilyConcernReport.familyConcerns.length - 1 ===
                      mainIndex ? (
                      <Box
                        className="cursorPointer"
                        sx={{
                          padding: '4px 8px 4px 8px',
                          borderRadius: '4px',
                          marginRight: '24px',
                          border: '1px solid #008C82',
                          backgroundColor: '#fff',
                        }}
                        onClick={() => {
                          createNewSection();
                        }}
                      >
                        <MediumTypography
                          labelid="IFSP.AddNewSection"
                          defaultlabel="+ Add New"
                          fontSize="12px"
                          fontweight={600}
                        />
                      </Box>
                    ) : (
                      canShowDeleteSection(mainIndex) && (
                        <Box
                          component={'div'}
                          className="cursorPointer flex__ align__items__center pr-md"
                          onClick={() => {
                            setDeleteNewSection(true);
                          }}
                          sx={{
                            padding: '4px 8px 4px 8px',
                            borderRadius: '4px',
                            marginRight: '24px',
                            border: '1px solid #EB4C60',
                            backgroundColor: '#fff',
                          }}
                        >
                          <DeleteIcon className="pr-xs" />
                          <MediumTypography
                            labelid="IFSP.DeleteNewSection"
                            defaultlabel="Delete"
                            fontSize="12px"
                            fontweight={600}
                          />
                        </Box>
                      )
                    )}
                    <DownArrow
                      className="cursorPointer"
                      onClick={() => {
                        setOpenAccordianIndex(mainIndex);
                        setOpenAccordian(true);
                      }}
                    />
                  </Box>
                )}
              </Box>
              {openAccordian && mainIndex === openAccordianIndex && (
                <Box component="div" key={transitionRenderKey}>
                  <Box
                    ref={parentRef}
                    style={{
                      pointerEvents: !ifspPermission.hasClientEditPermission
                        ? 'none'
                        : 'auto',
                      opacity: !ifspPermission.hasClientEditPermission
                        ? '0.5'
                        : '1 ',
                    }}
                    onKeyDownCapture={(e) => {
                      if (!ifspPermission.hasClientEditPermission) {
                        e.preventDefault();
                        e.stopPropagation();
                      }
                    }}
                    onFocus={() => {
                      if (!ifspPermission.hasClientEditPermission) {
                        if (parentRef.current) parentRef.current.focus();
                      }
                    }}
                  >
                    <Box sx={{ alignItems: 'center', display: 'inline-flex' }}>
                      <MediumTypography
                        sxProps={{
                          marginLeft: '4px',
                          marginRight: '24px',
                          fontFamily: 'Lato-Regular',
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                        labelid={'IFSP.concerns'}
                        defaultlabel={
                          'Concerns: What keeps us up at night? What would we like to be able to do?'
                        }
                      />
                    </Box>
                    <Box sx={{ paddingTop: '8px' }}>
                      <CommentTextbox
                        className="translate"
                        name={'concern'}
                        placeholder={'Enter your comments'}
                        rows={5}
                        maxLength={5000}
                        Value={
                          ifspFamilyConcernReport.familyConcerns[mainIndex]
                            .concernsComment
                        }
                        handlechange={(value) => {
                          dispatch(
                            updateIfspFamilyConcernReport({
                              ...ifspFamilyConcernReport,
                              familyConcerns:
                                ifspFamilyConcernReport.familyConcerns.map(
                                  (item, index) => {
                                    if (index === mainIndex) {
                                      return {
                                        ...item,
                                        concernsComment: value || null,
                                      };
                                    }
                                    return item;
                                  },
                                ),
                            }),
                          );
                        }}
                        style={{
                          width: '840px',
                        }}
                      />
                    </Box>

                    <Box sx={{ alignItems: 'center', display: 'inline-flex' }}>
                      <MediumTypography
                        sxProps={{
                          marginLeft: '4px',
                          marginRight: '24px',
                          fontFamily: 'Lato-Regular',
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                        labelid={'IFSP.priorities'}
                        defaultlabel={
                          'Priorities: What is important for us, our child and family? Where would we like to focus our energy/effort?'
                        }
                      />
                    </Box>
                    <Box sx={{ paddingTop: '8px' }}>
                      <CommentTextbox
                        className="translate"
                        name={'concern'}
                        placeholder={'Enter your comments'}
                        rows={5}
                        maxLength={5000}
                        Value={
                          ifspFamilyConcernReport.familyConcerns[mainIndex]
                            .prioritiesComment
                        }
                        handlechange={(value) => {
                          dispatch(
                            updateIfspFamilyConcernReport({
                              ...ifspFamilyConcernReport,
                              familyConcerns:
                                ifspFamilyConcernReport.familyConcerns.map(
                                  (item, index) => {
                                    if (index === mainIndex) {
                                      return {
                                        ...item,
                                        prioritiesComment: value || null,
                                      };
                                    }
                                    return item;
                                  },
                                ),
                            }),
                          );
                        }}
                        style={{
                          width: '840px',
                        }}
                      />
                    </Box>

                    <Box component="div">
                      <MediumTypography
                        labelid="IFSP.resourcesToSupport"
                        defaultlabel="Resources to Support the Child's Development:"
                        fontSize="16px"
                        fontweight={600}
                        textColor="#2A4241"
                      />
                      <MediumTypography
                        labelid="IFSP.listResources"
                        defaultlabel="What do we have or would be helpful to have? List resources that the family may have and may need."
                        textColor="#2A4241"
                        className="mt-sm"
                      />
                    </Box>

                    <Box sx={{ alignItems: 'center', display: 'inline-flex' }}>
                      <MediumTypography
                        sxProps={{
                          marginLeft: '4px',
                          marginRight: '24px',
                          fontFamily: 'Lato-Regular',
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                        labelid={'IFSP.materialResources'}
                        defaultlabel={
                          'Material Resources: (Toys/equipment, Child Care, Financial, etc.)'
                        }
                      />
                    </Box>
                    <Box sx={{ paddingTop: '8px' }}>
                      <CommentTextbox
                        className="translate"
                        name={'concern'}
                        placeholder={'Enter your comments'}
                        rows={5}
                        maxLength={5000}
                        Value={
                          ifspFamilyConcernReport.familyConcerns[mainIndex]
                            .materialResourceComment
                        }
                        handlechange={(value) => {
                          dispatch(
                            updateIfspFamilyConcernReport({
                              ...ifspFamilyConcernReport,
                              familyConcerns:
                                ifspFamilyConcernReport.familyConcerns.map(
                                  (item, index) => {
                                    if (index === mainIndex) {
                                      return {
                                        ...item,
                                        materialResourceComment: value || null,
                                      };
                                    }
                                    return item;
                                  },
                                ),
                            }),
                          );
                        }}
                        style={{
                          width: '840px',
                        }}
                      />
                    </Box>

                    <Box sx={{ alignItems: 'center', display: 'inline-flex' }}>
                      <MediumTypography
                        sxProps={{
                          marginLeft: '4px',
                          marginRight: '24px',
                          fontFamily: 'Lato-Regular',
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                        labelid={'IFSP.informationalResources'}
                        defaultlabel={
                          'Informational Resources: (Infant/toddler development, diagnosis, activities to do together, community opportunities, etc.)'
                        }
                      />
                    </Box>
                    <Box sx={{ paddingTop: '8px' }}>
                      <CommentTextbox
                        className="translate"
                        name={'concern'}
                        placeholder={'Enter your comments'}
                        rows={5}
                        maxLength={5000}
                        Value={
                          ifspFamilyConcernReport.familyConcerns[mainIndex]
                            .informationalResourceComment
                        }
                        handlechange={(value) => {
                          dispatch(
                            updateIfspFamilyConcernReport({
                              ...ifspFamilyConcernReport,
                              familyConcerns:
                                ifspFamilyConcernReport.familyConcerns.map(
                                  (item, index) => {
                                    if (index === mainIndex) {
                                      return {
                                        ...item,
                                        informationalResourceComment:
                                          value || null,
                                      };
                                    }
                                    return item;
                                  },
                                ),
                            }),
                          );
                        }}
                        style={{
                          width: '840px',
                        }}
                      />
                    </Box>

                    <Box sx={{ alignItems: 'center', display: 'inline-flex' }}>
                      <MediumTypography
                        sxProps={{
                          marginLeft: '4px',
                          marginRight: '24px',
                          fontFamily: 'Lato-Regular',
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                        labelid={'IFSP.supportiveResources'}
                        defaultlabel={
                          'Supportive Resources: (Connection to other parents, friends & family members, medical/other professionals etc.)'
                        }
                      />
                    </Box>
                    <Box sx={{ paddingTop: '8px' }}>
                      <CommentTextbox
                        className="translate"
                        name={'concern'}
                        placeholder={'Enter your comments'}
                        rows={5}
                        maxLength={5000}
                        Value={
                          ifspFamilyConcernReport.familyConcerns[mainIndex]
                            .supportiveResourceComment
                        }
                        handlechange={(value) => {
                          dispatch(
                            updateIfspFamilyConcernReport({
                              ...ifspFamilyConcernReport,
                              familyConcerns:
                                ifspFamilyConcernReport.familyConcerns.map(
                                  (item, index) => {
                                    if (index === mainIndex) {
                                      return {
                                        ...item,
                                        supportiveResourceComment:
                                          value || null,
                                      };
                                    }
                                    return item;
                                  },
                                ),
                            }),
                          );
                        }}
                        style={{
                          width: '840px',
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          ))}
          <Box component="div" className="flex__ justifyContent-FlexEnd mb-sm">
            <ButtonComponent
              className="btn-primary btn-cancel"
              labelId={'cancelText'}
              defaultLabelId="Cancel"
              variantType="outlined"
              onClick={() => {
                if (isFamilyConcernsChanged) {
                  setOpenUnSavedModal(true);
                } else {
                  setOpenUnSavedModal(false);
                }
              }}
              disabled={!ifspPermission.hasClientEditPermission}
            />
            <ButtonComponent
              className="btn-primary btn-submit  ml-md"
              labelId="IFSP.SaveFamilyConcernsPrioritiesAndResources"
              defaultLabelId="Save Family Concerns, Priorities and Resources"
              variantType="contained"
              onClick={() => {
                addOrUpdateIfspReportDetails();
              }}
              disabled={!ifspPermission.hasClientEditPermission}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FamilyConcernsPrioritiesandResourcesReport;
